
import React from 'react';
import { Button, Form } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import Emoji from '../components/Emoji';
import { GREEN, WHITE_TEXT } from '../helpers/constants/colors';


const BugReporting = () => {
    const navigate = useNavigate()
    const handleClick = (e) => {
        e.preventDefault()
        alert("Thank you for submitting, feel free to go ashore...")
        alert("THE VERY NEXT TIME WE MAKE PORT!")
        navigate("/")
    }
    return (
        <div className='BugReporting'>
            <Form>
                <Form.Group className="mb-3" controlId="exampleForm.ControlTextarea1">
                    <Form.Label><span className={WHITE_TEXT}>Bug to Report</span></Form.Label>
                    <Form.Control as="textarea" rows={4} placeholder="tell us about your problem" />
                    <br />

                    <div align="center">
                        <Button href="/budget"><Emoji symbol='⬅'/> Go Back</Button>
                        <Button variant={GREEN} onClick={handleClick}>Submit <Emoji symbol="✔️"/></Button>
                    </div>
                </Form.Group>
            </Form>
        </div>
    )
}



export default BugReporting;
